import { create } from 'zustand';
import { StoreApi, UseBoundStore } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

import { FontsSlice, createFontsSlice } from './fonts.slice';
import { PagesSlice, createPagesSlice } from './pages.slice';
import { ProjectSlice, createProjectSlice } from './project.slice';

/**
 * Define an interface describing the overall projects store shape.
 */
export type IProjectsStore = FontsSlice & ProjectSlice & PagesSlice;

/**
 * Create the projects store.
 */
export const useProjectsStore = create<IProjectsStore>()(
  devtools(
    immer((...args) => ({
      ...createProjectSlice(...args),
      ...createPagesSlice(...args),
      ...createFontsSlice(...args),
    })),
    { name: 'Features | Projects' }
  )
);

export type ProjectStoreInjector = UseBoundStore<StoreApi<IProjectsStore>>;
